/*
 * ST 2026-08-21 — Finanzierungs-Karte oeffnet den Drawer auch nach einem
 * Variantenwechsel.
 *
 * theme.js bindet die Drawer-Trigger EINMALIG im connectedCallback des
 * <drawer-element>:
 *
 *   this.controls.forEach((button) => this.on(button, 'click', ...))
 *   // controls = document.querySelectorAll('[aria-controls="<id>"]')
 *
 * Beim Variantenwechsel ersetzt renderProductInfo den Finanzierungsblock
 * vollstaendig (`destination.innerHTML = source.innerHTML`). Der Button ist
 * danach ein neues Element ohne Listener, und der Drawer bindet nicht nach:
 * er liegt in einer eigenen Section, die nicht neu gerendert wird. Beim
 * Groessentabellen-Modal faellt das nicht auf, weil dort Trigger UND Modal im
 * selben neu gerenderten Fieldset liegen.
 *
 * Loesung: ein einziger delegierter Listener. Die beim Laden vorhandenen
 * Trigger merken wir uns — die bedient theme.js weiterhin selbst, sonst wuerde
 * `onButtonClick` togglen und der Drawer ginge sofort wieder zu. Alles, was
 * spaeter nachgerendert wird, uebernehmen wir.
 *
 * Rollback: diese Datei + die Script-Zeile in sections/main-product.liquid.
 */
(() => {
  const SELECTOR = '.product-financing__card[aria-controls]';
  const themeBound = new WeakSet(document.querySelectorAll(SELECTOR));

  document.addEventListener('click', (event) => {
    const button = event.target.closest(SELECTOR);
    if (!button || themeBound.has(button)) return;

    const drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer || typeof drawer.show !== 'function') return;

    event.preventDefault();
    drawer.hasAttribute('open') ? drawer.hide() : drawer.show(button);
  });
})();
